export default __webpack_public_path__ + "static/media/alert_simple.b3d5081e.ogg";